import { useForm, Controller, SubmitHandler } from "react-hook-form";
import DatePicker from "react-datepicker";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "react-datepicker/dist/react-datepicker.css";
import { InputDiv } from "../../assets/StyledComponent/Input/Input.Style";
import { useState, useEffect } from "react";
import { sCmpUserReportService } from "../../services/sCmpUserReportService";
import {
  getFoodTotalExpenseDownloadService,
  getFoodTotalExpenseService,
  getFoodCompanyExpenseService,
  getCmpFoodTotalExpenseDownloadService,
} from "../../services/cFoodExpenseReportService";
import { useStore } from "../../store";
import "../TotalExpenseReport/styles.css";
import {
  GET_CMP_USER_REPORT_FAILURE,
  GET_CMP_USER_REPORT_SUCCESS,
} from "../../container/SCmpUserReport/types";

import {
  GET_CFOOD_TOTAL_EXPENSE_REPORT,
  GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
  SET_ALL_REPORT_BY_FALSE,
  SET_FROM_TIME,
  SET_REPORT_BY_ENGLISH_DATE,
  SET_REPORT_BY_ENGLISH_SELECT,
  SET_TO_TIME,
  UNSET_REPORT_BY_ENGLISH_SELECT,
} from "../../container/FoodReport/types";

type FormInputs = {
  name: string;
  date: Date;
  fromDate1: any;
  ToDate1: any;
  id: string;
};
type TReportProps = {
  companyId: string;
  reportType?: string;
};

const ExpenseReport = ({ companyId, reportType }: TReportProps) => {
  const [state, dispatch]: any = useStore();
  const valueOfEye = state.foodReportReducer?.enlgishSelect;

  //console.log("companyId", companyId); //true

  const [date, setDate] = useState<any>({
    fromDate: new Date(),
    toDate: new Date(),
  });

  // console.log(reportType);

  const { handleSubmit } = useForm<FormInputs>();

  useEffect(() => {
    var today = new Date();
    var day = String(today.getDate()).padStart(2, "0");
    var month = String(today.getMonth() + 1).padStart(2, "0");
    var year = today.getFullYear();
    var nextMonth = `0${parseInt(month) - 1}`;

    var nextMonth = month === "01" ? "01" : `0${parseInt(month) - 1}`;

    const fromDate = new Date(year + "-" + nextMonth + "-" + day);
    const toDate = new Date(year + "-" + month + "-" + day);
    setDate({ fromDate, toDate });
  }, []);
  // const fromDateEng = date.fromDate.toISOString().slice(0, 10);

  // console.log(
  //   "start date convert method",
  //   date.fromDate.toLocaleDateString("zh-Hans-CN")
  // );
  // console.log("start date splice method ", fromDateEng);

  // const toDateEng = date.toDate.toISOString().slice(0, 10);
  // console.log("end date", toDateEng);

  const onSubmit: SubmitHandler<FormInputs> = async () => {
    const fromDateEng = date.fromDate.toLocaleDateString("zh-Hans-CN");

    const toDateEng = date.toDate.toLocaleDateString("zh-Hans-CN");

    if (companyId) {
      getCmpFoodTotalExpenseDownloadService(fromDateEng, toDateEng, companyId);
    } else {
      getFoodTotalExpenseDownloadService(fromDateEng, toDateEng);
    }
  };

  const handleFoodTotalExpense = () => {
    // setEyeOpen((prevState: boolean) => !prevState);
    // const fromDateEng = date.fromDate.toISOString().slice(0, 10);
    const fromDateEng = date.fromDate.toLocaleDateString("zh-Hans-CN");
    const toDateEng = date.toDate.toLocaleDateString("zh-Hans-CN");

    dispatch({
      type: SET_REPORT_BY_ENGLISH_SELECT,
    });

    valueOfEye === true &&
      dispatch({
        type: UNSET_REPORT_BY_ENGLISH_SELECT,
      });
    dispatch({
      type: SET_FROM_TIME,
      fromDate: fromDateEng,
    });
    dispatch({
      type: SET_TO_TIME,
      toDate: toDateEng,
    });
    if (companyId) {
      if (reportType === "Food Report") {
        getFoodCompanyExpenseService(fromDateEng, toDateEng, companyId)
          .then((res: any) => {
            dispatch({
              type: GET_CFOOD_TOTAL_EXPENSE_REPORT,
              cTotalExpenseReport: res,
            });
          })
          .catch((err) => {
            dispatch({
              type: GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
              cTotalExpenseReportError: err,
            });
          });
      } else {
        sCmpUserReportService(fromDateEng, toDateEng, companyId)
          .then((res: any) => {
            dispatch({
              type: GET_CMP_USER_REPORT_SUCCESS,
              SCmpUserReport: res,
            });
          })
          .catch((err: any) => {
            dispatch({
              type: GET_CMP_USER_REPORT_FAILURE,
              SCmpUserReportError: err,
            });
          });
      }
    } else
      getFoodTotalExpenseService(fromDateEng, toDateEng)
        .then((res: any) => {
          dispatch({
            type: GET_CFOOD_TOTAL_EXPENSE_REPORT,
            cTotalExpenseReport: res,
          });
        })
        .catch((err) => {
          dispatch({
            type: GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
            cTotalExpenseReportError: err,
          });
        });
  };

  return (
    <InputDiv>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-80 mt-2 text-center rounded d-flex"
        style={{
          // width: "68.5%",
          display: "flex",
          justifyItems: "flex-start",
          // flexDirection: "row",
          // justifyContent: "space-between",
        }}
      >
        <br />

        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            margin: "0px 22px",
            fontWeight: "500",
          }}
        >
          English Start Date
        </label>
        <DatePicker
          onChange={(e: any) => {
            dispatch({
              type: SET_ALL_REPORT_BY_FALSE,
            });
            setDate({ ...date, fromDate: e });
          }}
          selected={date.fromDate}
          placeholderText="Enter Date"
          className="calender"
        />
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            marginLeft: "34px",
            marginRight: "48px",
            fontWeight: "500",
          }}
        >
          English End Date
        </label>
        <DatePicker
          onChange={(e: any) => {
            dispatch({
              type: SET_ALL_REPORT_BY_FALSE,
            });
            setDate({ ...date, toDate: e });
          }}
          selected={date.toDate}
          placeholderText="Enter Date"
          className="calender"
        />
        {/* <button className="searchBtn"> Download</button> */}

        <button
          className="searchBtn"
          type="button"
          style={{
            backgroundColor: valueOfEye ? "#e55607" : "#999",
          }}
          onClick={handleFoodTotalExpense}
        >
          {valueOfEye ? <AiFillEye /> : <AiFillEyeInvisible />}
        </button>
      </form>
    </InputDiv>
  );
};

export default ExpenseReport;
